module.exports = __webpack_public_path__ + "static/media/person-smiling-at-phone.99283f74.jpg";